import { useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Hidden, Icon, IconButton, Typography, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

// local imports
import FusePageCarded from '@fuse/core/FusePageCarded';
import { Breadcrumb } from 'app/components/atoms';
import CustomerSidebarContent from './sidebar-content';
/* Pages */
import CustomerInfo from './tabs/customer-info';
import CustomerAgreements from './tabs/customer-agreements';
import CustomerPharmacies from './tabs/customer-pharmacies';
import CustomerOrders from './tabs/customer-orders';
import { useCustomerDetailService } from 'app/hooks/services';

// Left Sidebar Header Component
const LeftSideHeader = () => (
  <Typography
    variant="h5"
    component="h1"
    className="flex justify-center pt-28 font-semibold tracking-wider">
    Müşteri Detay
  </Typography>
);

// Content Toolbar Header Component
const ContentToolbar = ({ nameSurname }) => (
  <>
    {nameSurname && (
      <div className="px-24">
        <Typography
          variant="h6"
          component="h1"
          className="flex justify-center font-semibold tracking-widest text-gray-800">
          {nameSurname}
        </Typography>
      </div>
    )}
  </>
);

// Header Component
const Header = ({ pageLayout }) => (
  <div className="w-full flex items-center ">
    <Hidden lgUp>
      <IconButton onClick={() => pageLayout.current.toggleLeftSidebar()}>
        <Icon>menu</Icon>
      </IconButton>
    </Hidden>
    <Breadcrumb title="Müşteri Detay" sidebar />
  </div>
);

// CUSTOMER DETAIL
const CustomerDetail = () => {
  const pageLayout = useRef(null);
  const history = useHistory();
  const { id } = useParams();
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const selectedTab = history?.location?.pathname.split('/').pop();

  // Fetch user detail data first;
  const { service } = useCustomerDetailService(id);

  // variables
  const isDataExist = !!service.data && !service.isNetworkError && !service.isError;
  const nameSurname = `${service?.data?.name} ${service?.data?.surname}`;

  return (
    <>
      <FusePageCarded
        ref={pageLayout}
        header={<Header pageLayout={pageLayout} />}
        contentToolbar={isDataExist && <ContentToolbar nameSurname={nameSurname} />}
        content={
          <div className="px-16 py-24">
            {selectedTab === 'customer-detail' && <CustomerInfo service={service} />}
            {selectedTab === 'customer-agreements' && <CustomerAgreements customerId={id} />}
            {selectedTab === 'customer-orders' && <CustomerOrders customerId={id} />}
            {selectedTab === 'customer-pharmacies' && <CustomerPharmacies customerId={id} />}
          </div>
        }
        leftSidebarHeader={lgUp && <LeftSideHeader />}
        leftSidebarContent={<CustomerSidebarContent customerId={id} />}
      />
    </>
  );
};

export default CustomerDetail;
